//import {setFieldVisibility} from "../../../../../apps/KpModule/actions"
//import {organizationActivities} from "../../staticEntities";

import {
    changeFieldProperty,
    setFieldEdition,
    setFieldListOptions,
    setFieldVisibility
} from "../../../../../apps/KpModule/actions";
import _ from "lodash";
import {getDataListList} from "../../../../../apps/KpModule/selectors";
import {isArrayInArrayOfArrays} from "../../../suiviEngagement/utils/usefulFunctions";

export const module_ = {
    object: 'LiberalityRecord',
    name: 'SupportModule',
    tKey: 'Dossier Support',
    objectIdentifier: 'applicationNumber',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'folder'
    },
    viewMap: {
        dt: [
            {path: 'applicationNumber', tKey: 'N° dossier'},
            {path: 'presentationDate', tKey: 'Présentation'},
            {path: 'typeOfFile', display: 'code'},
            {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire'},
            {path: 'benefactor'},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)'},
            {path: 'CNDABeneficiaries', tKey: 'CNDA Pour'},
            {path: 'netForecast', tKey: 'Net Prévisionnel (€)', tooltip: true},
            {path: 'CNDAShare', tKey: 'Dont part CNDA'},

            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle']},
            {path: 'updatedAt', tKey: 'Date'},
            {path: 'updatedBy', tKey: 'Utilisateur'},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: {
            fields: [
                //{path: 'applicationNumber', tKey: 'N° dossier', disabled: true},
                {path: 'partiesSection', data: 'ANCIENS CHAMPS', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},

                {path: 'beneficiary'},
                {path: 'testator'},
                {path: 'testatorComment', type: "richTextEditor"},
                {path: 'object', type: "richTextEditor"},
                {path: 'netAssets'},
                {path: 'netAssetsDetails', type: "richTextEditor"},

                {path: 'lifeInsuranceNetAmount'},
                {path: 'lifeInsuranceNetAmountDetails', type: "richTextEditor"},

                {path: 'actualFields', data: 'CHAMPS Actuels', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},

                {
                    path: 'typeOfFile',
                    sortList: false,
                    display: 'fullName',
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            if(newValue) {
                                const state = store.getState()
                                const isLegs = newValue.id === 'legs'
                                const isLifeInsurance = newValue.id === 'lifeInsurance'
                                const isDonationOrGiftsOnInheritance = ['donations', 'giftsOnInheritance'].includes(newValue.id)

                                const grossAssetsField = module.viewMap.form.fields.find(field => field.path === 'grossAssets')
                                const grossAssetsDetailsField = module.viewMap.form.fields.find(field => field.path === 'grossAssetsDetails')

                                const netAssetsField = module.viewMap.form.fields.find(field => field.path === 'assets')
                                const netAssetsDetailsField = module.viewMap.form.fields.find(field => field.path === 'assetsDetails')


                                const liabilitiesField = module.viewMap.form.fields.find(field => field.path === 'grossLiabilities')
                                const liabilitiesDetailsField = module.viewMap.form.fields.find(field => field.path === 'grossLiabilitiesDetails')
                                const actFeesField = module.viewMap.form.fields.find(field => field.path === 'actsFees')
                                const actFeesDetailsField = module.viewMap.form.fields.find(field => field.path === 'actsFeesDetails')

                                store.dispatch(setFieldVisibility(grossAssetsField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(grossAssetsDetailsField.id, !isLifeInsurance))

                                store.dispatch(setFieldVisibility(netAssetsField.id, isLifeInsurance))
                                store.dispatch(setFieldVisibility(netAssetsDetailsField.id, isLifeInsurance))

                                store.dispatch(setFieldVisibility(liabilitiesField.id, isLegs))
                                store.dispatch(setFieldVisibility(liabilitiesDetailsField.id, isLegs))
                                store.dispatch(setFieldVisibility(actFeesField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(actFeesDetailsField.id, !isLifeInsurance))

                                if(!isLegs) {
                                    liabilitiesField.setValue(0)
                                    liabilitiesDetailsField.setValue('')
                                }

                                if(isLifeInsurance) {
                                    actFeesField.setValue(0)
                                    actFeesDetailsField.setValue('')

                                    grossAssetsField.setValue(0)
                                    grossAssetsDetailsField.setValue('')
                                }

                                if(!isLifeInsurance) {
                                    netAssetsField.setValue(0)
                                    netAssetsDetailsField.setValue('')
                                }

                                const repartitionField = module.viewMap.form.fields.find(field => field.path === 'distribution')

                                const ownLiabilitiesListField = repartitionField.viewMap.dt.fields.find(field => field.path === 'ownLiabilities')
                                const ownLiabilitiesFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'ownLiabilities')

                                const qualificationListField = repartitionField.viewMap.dt.fields.find(field => field.path === 'qualification')
                                const qualificationFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'qualification')

                                const typeOfPropertyListField = repartitionField.viewMap.dt.fields.find(field => field.path === 'typeOfProperty')
                                const typeOfPropertyFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'typeOfProperty')

                                store.dispatch(setFieldVisibility(ownLiabilitiesListField.id, isLegs))
                                store.dispatch(setFieldVisibility(ownLiabilitiesFormField.id, isLegs))

                                store.dispatch(setFieldVisibility(qualificationListField.id, isLegs))
                                store.dispatch(setFieldVisibility(qualificationFormField.id, isLegs))

                                store.dispatch(setFieldVisibility(typeOfPropertyListField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(typeOfPropertyFormField.id, !isLifeInsurance))

                                const typeOfPropertyDisplay = isLegs ? 'category' : 'natureOfProperty'

                                store.dispatch(changeFieldProperty(typeOfPropertyListField.id, 'tKey', typeOfPropertyDisplay))
                                store.dispatch(changeFieldProperty(typeOfPropertyFormField.id, 'tKey', typeOfPropertyDisplay))

                                const options = getDataListList(state, 'm-C-supportModule.AssetPartition_typeOfProperty')
                                const filteredOptions = options.filter(option => {
                                    return isLegs
                                        ? option.category
                                        : isDonationOrGiftsOnInheritance
                                            ? option.natureOfProperty
                                            : false
                                })

                                store.dispatch(setFieldListOptions(typeOfPropertyFormField.id, _.map(filteredOptions, "id")))

                            }
                        }
                    }
                },
                {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', filters: ['eligibleToLiberalityProcess']},

                {path: 'comment', type: "richTextEditor"},

                {path: 'grossAssets', tKey: 'Actif brut (€)', wholePositiveNumber: true, default: 0, required: true},
                {path: 'grossAssetsDetails', tKey: 'Détails liés à l’actif brut', type: "richTextEditor"},

                {path: 'assets', tKey: 'Actif (€)', wholePositiveNumber: true, default: 0, required: true},
                {path: 'assetsDetails', tKey: 'Détails liés à l’actif (€)', type: "richTextEditor",},

                {path: 'grossLiabilities', tKey: 'Passif successoral (€)', wholePositiveNumber: true, default: 0, required: true},
                {path: 'grossLiabilitiesDetails', tKey: 'Détails liés au passif successoral', type: "richTextEditor"},

                {path: 'actsFees', tKey: 'Frais d’actes (€)', wholePositiveNumber: true, default: 0, required: true},
                {path: 'actsFeesDetails', tKey: 'Détails liés aux frais d’actes', type: "richTextEditor"},

                {
                    path: 'distribution',
                    tKey: 'Répartition',
                    viewMap: {
                        dt: [
                            {path: 'confFor', tKey: 'Pour'},
                            {path: 'beneficiary', display: 'zipCodeAndName'},
                            {path: 'qualification', tKey: 'QF'},
                            {path: 'typeOfProperty', tKey: 'categories'},
                            {path: 'ownLiabilities'},
                            {path: 'share', tKey: 'Quote-part'},
                        ],
                        form: [
                            /*
                            {path: 'partiesSection1', section: "partiesSection", data: 'ANCIENS CHAMPS', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},
                            {path: 'typeOfFile'},
                            {path: 'typeOfProperty'},

                            {path: 'partiesSection2', section: "partiesSection", data: 'CHAMPS ACTUELS', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},
                             */

                            {path: 'confFor', tKey: 'CONF. DEFENSE DE L’ANIMAL POUR'},
                            {path: 'beneficiary', display: 'zipCodeAndName', filters: ['isAssociation'],},
                            {path: 'qualification'},
                            {path: 'typeOfProperty', fieldPath: ['id', 'name', 'category', 'natureOfProperty'], tKey: 'category'},
                            {path: 'ownLiabilities', default: 0},
                            {path: 'share', tKey: 'Quote-part', required: true, default: 0},
                            'group'
                        ],
                    }
                },

                {path: 'conversations', tKey: "interactionZone"},

                {path: 'applicationNumber', hidden: true},
                {path: 'status', hidden: true},
            ]
        }
    }
}
